import React, { useState, useEffect } from "react";
import Button from '@material-ui/core/Button';
import { useForm, Controller } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import { decode as htmlDecode } from 'html-entities';
import { usePlacesWidget } from "react-google-autocomplete";
import { useSetRecoilState, useRecoilState } from 'recoil';

// import LocationMap from "../../../GoogleMap/GoogleMap";
import LocationMap from "../../../GoogleMap/GoogleMap_New";

import {
  geoBoundaryTabListState,
  geoBoundaryTabIndexState,
  geoBoundaryListRefreshState,

} from '../../../../../core/store/GeoBoundaryStore';
import { useSpinner } from "../../../../../core/contexts/SpinnerContext";
import { useNotification } from "../../../../../core/contexts/NotificationContext";
import * as GeoBoundaryApi from '../../../../Common/Apis/GeoBoundaryApi';



const GeoBoundaryDetail = ({ item }) => {

  const { control, handleSubmit, setValue, getValues, reset, formState: { errors } } = useForm({
    defaultValues: {
      geoName: htmlDecode(item?.GeoBoundaryName || ""),
      geoAddress: htmlDecode(item?.Address || ""),
      geoLatitude: item?.Latitude || "",
      geoLongitude: item?.Longitude || "",
      geoSuburb: item?.Suburb || "",
      geoPostCode: item?.PostCode || "",

    }
  });

  const [geoShape, setGeoShape] = useState(item);
  const [geoType, setGeoType] = useState(Number(item?.GeoBoundaryTypeId) || 1);
  const [isOffroad, setIsOffroad] = useState(item?.IsOffroad === "True" ? true : false);
  const [spotMarker, setSpotMarker] = useState(item ? { lat: item.Latitude, lng: item.Longitude } : null);
  const [geoBoundaryTabList, setGeoBoundaryTabList] = useRecoilState(geoBoundaryTabListState);
  const [geoBoundaryListRefresh, setGeoBoundaryListRefresh] = useRecoilState(geoBoundaryListRefreshState);
  const setTabIndex = useSetRecoilState(geoBoundaryTabIndexState);

  const { showSuccess } = useNotification();
  const { setSpinner } = useSpinner();

  const { ref: addressRef } = usePlacesWidget({

    onPlaceSelected: (place) => {
      if (place) {
        setValue("geoAddress", place.formatted_address);
        setValue("geoLatitude", parseFloat(place.geometry.location.lat()));
        setValue("geoLongitude", parseFloat(place.geometry.location.lng()));
        setSpotMarker({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });

        //place.address_components.length is flexiable
        place.address_components.forEach((item) => {
          if (item.types.find((o) => o === 'sublocality') && item.long_name !== "") {
            setValue("geoSuburb", item.long_name);
          }
          else if (item.types.find((o) => o === 'locality')) {
            setValue("geoSuburb", item.long_name);
          }
          else if (item.types.find((o) => o === 'postal_code')) {
            setValue("geoPostCode", item.long_name);
          }
        });
      }
    },
    options: {
      componentRestrictions: { country: ["NZ", "AU"] },
      types: ["geocode"],
    },
  });

  const resetForm = () => {
    reset();
    setGeoShape(undefined);
  };

  useEffect(() => {
    if (item) {

      //activate this tab
      const thisIndex = geoBoundaryTabList.findIndex((i) => i.GeoBoundaryId === item.GeoBoundaryId);
      setTabIndex(thisIndex + 2);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const drawingCompleted = (e) => {

    if (e) {
      setGeoShape({
        GeoBoundaryId: "1",
        GeoBoundaryTypeId: "1",
        GeoPath: e.getPath(),
        AccountId: "",
        AccountName: "",
        GeoBoundaryName: "",
        GeoBoundaryShape: "",
        Latitude: "",
        Longitude: "",
        Radius: "",
        Address: "",
        Suburb: "",
        PostCode: "",
        IsOffroad: ""
      });

      const bounds = new window.google.maps.LatLngBounds();
      e.getPath().forEach((i) => bounds.extend(i));
      const newCenter = bounds.getCenter();

      setValue("geoLatitude", Number(newCenter.lat().toFixed(6)));
      setValue("geoLongitude", Number(newCenter.lng().toFixed(6)));
      setSpotMarker({ lat: newCenter.lat(), lng: newCenter.lng() });
    }
    else {
      setGeoShape(undefined);
    }
  };

  const onSubmit = handleSubmit(async (data) => {


    // if (geoAddress === "") {
    //   console.log('errors', errors);
    //   errors.txtGeoAddress = 1;
    //   return;
    // }

    setSpinner(true);

    try {
      const geoPaths = [];
      if (geoShape?.GeoPath) {
        geoShape.GeoPath.getArray().forEach((i) => geoPaths.push(i.lng() + ',' + i.lat()));
      }

      const geoBoundary = {
        GeoBoundaryName: data.geoName,
        GeoBoundaryTypeId: geoType,
        Latitude: data.geoLatitude,
        Longitude: data.geoLongitude,
        Radius: 1,
        Address: data.geoAddress,
        Suburb: data.geoSuburb,
        PostCode: data.geoPostCode,
        IsOffroad: isOffroad,
        GeoPath: geoPaths.join()
      };

      if (item) {

        //If geo boundary does not changed
        if (geoBoundary.GeoPath === "") {

          const polygonArray = item.GeoBoundaryShape.split("((")[1].split(" ").join(",").split(",");
          polygonArray.pop();
          polygonArray.pop();

          const polyCoords = [];
          for (let i = 0; i < polygonArray.length; i = i + 2) {
            polyCoords.push(polygonArray[i] + "," + polygonArray[i + 1]);
          }

          geoBoundary.GeoPath = polyCoords.join();
        }


        //update
        await GeoBoundaryApi.updateGeoBoundary(item.GeoBoundaryId, geoBoundary);

        const filtered = geoBoundaryTabList.filter((i) => {
          return i.GeoBoundaryId !== item.GeoBoundaryId;
        });

        setGeoBoundaryTabList(filtered);
      }
      else {
        //insert

        await GeoBoundaryApi.createGeoBoundary(geoBoundary);
        resetForm();
      }

      showSuccess("success", "sucessfully saved", "", 3000, null);

      setTabIndex(0);
      setGeoBoundaryListRefresh(!geoBoundaryListRefresh);


    }
    catch (err) {
      console.log("onSubmit.err", err);
    }
    setSpinner(false);

  });

  return (
    <>
      <form >
        <div className="row">
          <div className="col-md-5  mt-3">
            <div className="tab-content" id="myTabContent">
              <div className="card">
                <div className="card-body">
                  <div className="row  mt-3">
                    <div className="col-6 ">

                      <Button
                        type="button"
                        className="mb-3 ml-3"
                        style={{ fontWeight: "600" }}
                        variant="contained"
                        color="primary"
                        onClick={onSubmit}
                      >
                        Save
                      </Button>

                    </div>
                    <div className="col-6 text-right ">
                      {!item &&
                        <Button
                          type="button"
                          className="mb-3 ml-3"
                          style={{ fontWeight: "600" }}
                          variant="contained"
                          color="default"
                          onClick={resetForm}
                        >
                          Reset
                        </Button>
                      }
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col">
                      <div className="p-number">
                        <Controller
                          name="geoName"
                          rules={{ required: true }}
                          control={control}
                          render={({ field }) => <TextField
                            {...field}
                            style={{ width: "100%" }}
                            label=""
                            variant="outlined"
                            size="small"
                            error={errors.geoName ? true : false}
                            helperText={""}
                          />}
                        />
                      </div>
                      <span className="p-num-span mr-2">
                        Name
                      </span>
                      {errors.geoName && <p className="text-danger2">should not be blank</p>}
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col">
                      <div className="p-number">
                        <Controller
                          name="geoAddress"
                          rules={{ required: true }}
                          control={control}
                          render={({ field }) => <TextField
                            {...field}
                            style={{ width: "100%" }}
                            label=""
                            variant="outlined"
                            size="small"
                            error={errors.geoAddress ? true : false}
                            helperText={""}
                            inputRef={(e) => {
                              if (e) addressRef.current = e;
                            }}
                          />}
                        />
                      </div>
                      <span className="p-num-span mr-2">
                        Address
                      </span>
                      {errors.geoAddress && <p className="text-danger2">should not be blank</p>}
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-sm-6">
                      <div className="p-number">
                        <Controller
                          name="geoSuburb"
                          rules={{ required: true }}
                          control={control}
                          render={({ field }) => <TextField
                            {...field}
                            style={{ width: "100%" }}
                            label=""
                            variant="outlined"
                            size="small"
                            error={errors.geoSuburb ? true : false}
                            helperText={""}
                          />}
                        />
                      </div>
                      <span className="p-num-span mr-2">
                        Suburb
                      </span>
                      {errors.geoSuburb && <p className="text-danger2">should not be blank</p>}
                    </div>
                    <div className="col-sm-6">
                      <div className="p-number">
                        <Controller
                          name="geoPostCode"
                          control={control}
                          render={({ field }) => <TextField
                            {...field}
                            style={{ width: "100%" }}
                            label=""
                            variant="outlined"
                            size="small"
                            error={errors.geoPostCode ? true : false}
                            helperText={""}
                          />}
                        />
                      </div>
                      <span className="p-num-span mr-2">
                        Postcode
                      </span>
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-sm-6">
                      <div className="p-number">

                        <Controller
                          name="geoLatitude"
                          control={control}
                          rules={{
                            required: true,
                            validate: {
                              positiveNumber: (value) => Number(value) !== 0,
                            }
                          }}
                          render={({ field }) => <TextField
                            {...field}
                            style={{ width: "100%" }}
                            label=""
                            variant="outlined"
                            size="small"
                            error={errors.geoLatitude ? true : false}
                            helperText={""}
                            inputProps={{ readOnly: true, }}
                          />}
                        />
                      </div>
                      <span className="p-num-span mr-2">
                        Latitude
                      </span>
                      {errors.geoLatitude && <p className="text-danger2">Should be a number</p>}
                    </div>
                    <div className="col-sm-6">
                      <div className="p-number">
                        <Controller
                          name="geoLongitude"
                          control={control}
                          rules={{
                            required: true,
                            validate: {
                              positiveNumber: (value) => Number(value) !== 0,
                            }
                          }}
                          render={({ field }) => <TextField
                            {...field}
                            style={{ width: "100%" }}
                            label=""
                            variant="outlined"
                            size="small"
                            error={errors.geoLongitude ? true : false}
                            helperText={""}
                            inputProps={{ readOnly: true, }}
                          />}
                        />
                      </div>
                      <span className="p-num-span mr-2">
                        Longitude
                      </span>
                      {errors.geoLongitude && <p className="text-danger2">Should be a number</p>}
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-sm-6">
                      <div className="">
                        <Switch
                          checked={isOffroad}
                          onChange={() => setIsOffroad(!isOffroad)}
                          color="primary"
                          name="chkOffroad"
                          inputProps={{ "aria-label": "primary checkbox" }}
                        />
                      </div>
                      <span className="p-num-span mr-2">Is Offroad</span>
                    </div>
                    <div className="col-sm-6">
                      <div className="p-number">
                        <FormControl
                          style={{ width: "100%" }}
                          variant="outlined"
                          size="small"
                        >
                          <Select
                            onChange={(e) => setGeoType(e.target.value)}
                            value={geoType || ""}
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            <MenuItem value="1">Polygon</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <span className="p-num-span mr-2">
                        Type
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-7  mt-3">
            <div className="tab-content" id="myTabContent">
              <div className="card">
                <div className="card-body">
                  <div id="map" className="map-full" style={{ height: "70vh" }}>
                    <LocationMap
                      isUseMarkerLabel={false}
                      zoom={18}
                      isCenter={true}
                      isDrawing={true}
                      height="96%"
                      width="96%"
                      drawedGeoBoundary={geoShape ? [geoShape] : null}
                      centerLatitude={getValues("geoLatitude") !== "" ? Number(getValues("geoLatitude")) : -36.858736}
                      centerLongitude={getValues("geoLongitude") !== "" ? Number(getValues("geoLongitude")) : 174.761915}
                      drawingCompleted={drawingCompleted}
                      spotMarker={spotMarker}
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default GeoBoundaryDetail;
